import * as React from "react";
import createSvgIcon from "./utils/create_svg_icon";

export default createSvgIcon(
  <path d="M 15.851562 11.351562 L 11.5 15.710938 L 9.398438 13.601562 L 10.101562 12.898438 L 11.5 14.289062 L 15.148438 10.648438 Z M 9 5 L 9 1 L 2 1 L 2 15 L 9 15 L 9 16 L 1 16 L 1 0 L 9.710938 0 L 14 4.289062 L 14 10 L 13 11 L 13 5 Z M 10 4 L 12.289062 4 L 10 1.710938 Z M 10 4 " />,
  "DocumentApproval",
);
